// src/hooks/useScreenLogging.js
// Custom hook for logging screen views
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import loggingService from '../services/loggingService';

/**
 * Custom hook to log screen views
 * Usage: useScreenLogging('ScreenName', { additionalContext })
 * 
 * @param {string} screenName - Name of the screen/component
 * @param {object} extraContext - Additional context to include in the log
 */
export const useScreenLogging = (screenName, extraContext = {}) => {
  const location = useLocation();

  useEffect(() => {
    // Update current screen in logging service
    loggingService.setCurrentScreen(screenName, location.pathname);

    // Log screen view
    loggingService.logInfo('screen_view', `User viewed ${screenName} screen`, {
      screenName,
      route: location.pathname,
      ...extraContext,
    }).catch(error => {
      // Silently fail - don't break the app if logging fails
      console.warn('[useScreenLogging] Failed to log screen view:', error);
    });
  }, [screenName, location.pathname, extraContext]);
};

export default useScreenLogging;

